import { Outlet } from 'react-router-dom';

import { PagePaths } from '@constants/paths';
import { EnergyDetails } from '@pages/EnergyDetails';
import { EnergyTariffForm } from '@pages/EnergyTariffForm';

export const energyRoutes = {
  path: '',
  element: <Outlet />,
  children: [
    {
      path: '',
      element: <EnergyTariffForm />,
    },
    {
      path: PagePaths.EnergyDetails,
      element: <EnergyDetails />,
    },
  ],
};
